export const supplierPricingEn = {
  "title": "My price list",
  "subtitle": "These prices apply to every new order unless the customer has a custom price list.",
  "lastUpdated": "Last updated: {{date}}, {{user}}",
  "save": "Save changes",
  "saving": "Saving...",
  "discard": "Discard changes",
  "exportExcel": "Export to Excel",
  "history": "Change history",
  "unsaved": "Unsaved changes",
  "tabs": {
    "default": "Default price list",
    "customers": "Customer price lists ({{count}})"
  },
  "diameter": {
    "title": "Material price by diameter",
    "subtitle": "ILS per ton, before VAT.",
    "col": "Diameter (mm)",
    "ribbed": "Ribbed ILS/t",
    "smooth": "Round ILS/t",
    "weldableExtra": "Weldable extra ILS/t",
    "fillMissing": "Fill missing",
    "addDiameter": "+ Add diameter",
    "missing": "Missing price"
  },
  "processing": {
    "title": "Processing & units",
    "subtitle": "Labour price added to material",
    "cut": "Cutting",
    "bend": "Bending",
    "unitPrice": "Hoops / units",
    "minUnit": "Minimum per unit",
    "shortRulePrefix": "Shapes up to",
    "shortRuleSuffix": "cm are charged per unit"
  },
  "transport": {
    "title": "Transport",
    "subtitle": "Delivery to site",
    "method": "Method",
    "methods": {
      "per_ton": "Per ton",
      "fixed": "Fixed amount",
      "none": "No transport"
    },
    "price": "Price",
    "freeAbove": "Free above",
    "minimum": "Minimum"
  },
  "general": {
    "title": "Waste & VAT",
    "vat": "VAT",
    "waste": "Default waste",
    "validity": "Quote validity",
    "days": "{{count}} days"
  },
  "exceptions": {
    "title": "Shape exceptions",
    "subtitle": "Shapes priced differently from the general price list.",
    "add": "+ Add shape exception",
    "sketch": "Sketch",
    "shape": "Shape",
    "chargeType": "Charge type",
    "processing": "Processing price",
    "unitPrice": "Unit price",
    "appliesTo": "Applies to",
    "all": "All customers",
    "selected": "Selected customers",
    "modalTitle": "Shape price exception",
    "save": "Save exception",
    "delete": "Delete",
    "confirmDelete": "Delete this exception?"
  },
  "charge": {
    "bend": "Bending",
    "cut": "Cutting",
    "unit": "Unit",
    "none": "No processing"
  },
  "units": {
    "perTon": "ILS/t",
    "ils": "ILS",
    "perUnit": "ILS/unit",
    "cm": "cm",
    "ton": "t",
    "percent": "%"
  },
  "customers": {
    "add": "+ Customer price list",
    "search": "Search customer",
    "customer": "Customer",
    "type": "Type",
    "discount": "Discount",
    "special": "Special prices",
    "transport": "Transport",
    "updated": "Updated",
    "edit": "Edit",
    "custom": "Custom",
    "rest": "All other customers use the default price list.",
    "diametersCount": "{{count}} diameters"
  },
  "customerTab": {
    "customMode": "Custom price list",
    "customModeDesc": "Special prices and discount for this customer",
    "defaultMode": "Default price list",
    "defaultModeDesc": "Customer pays the general price list",
    "discount": "Material discount",
    "waste": "Waste",
    "paymentTerms": "Payment terms",
    "terms": {
      "cash": "Cash",
      "net30": "Net 30",
      "net60": "Net 60",
      "net90": "Net 90"
    },
    "transport": "Transport",
    "transportModes": {
      "pricelist": "By price list",
      "custom": "Custom"
    },
    "overridesTitle": "Special prices per diameter",
    "addOverride": "+ Special diameter price",
    "general": "Price list ILS/t",
    "forCustomer": "Customer ILS/t",
    "diff": "Difference",
    "restRow": "All others",
    "note": "Applies to new orders of this customer.",
    "cancel": "Cancel",
    "save": "Save customer price list",
    "tabDetails": "Details",
    "tabPricing": "Pricing"
  },
  "order": {
    "priceList": "Order price list",
    "showPrices": "Show prices",
    "priceCol": "Price (ILS)",
    "chargeCol": "Processing",
    "summary": "Pricing",
    "material": "Material ({{tons}} t)",
    "bend": "Bending",
    "cut": "Cutting",
    "units": "Units",
    "transport": "Transport",
    "discount": "Customer discount {{pct}}%",
    "subtotal": "Total before VAT",
    "vat": "VAT {{pct}}%",
    "total": "Total",
    "createQuote": "Create customer quote",
    "analysis": "Financial analysis",
    "missingPrices": "{{count}} rows have no price - update the price list",
    "saveToApplyServer": "Prices are stored on the order after saving"
  },
  "analysis": {
    "title": "Order financial analysis",
    "subtotal": "Total before VAT",
    "avgPerTon": "Average per ton",
    "processing": "Processing & units",
    "transport": "Transport",
    "split": "Breakdown",
    "byDiameter": "By diameter",
    "weight": "Weight (t)",
    "total": "Total ILS",
    "print": "Print",
    "note": "* Before transport and customer discount."
  },
  "quote": {
    "title": "Quote #{{no}}",
    "date": "Date",
    "validUntil": "Valid until",
    "order": "Order",
    "to": "To",
    "site": "Site",
    "delivery": "Delivery",
    "terms": "Payment terms",
    "description": "Description",
    "qty": "Qty",
    "weight": "Weight kg",
    "perTon": "ILS/t",
    "sum": "Total ILS",
    "notes": [
      "Prices in ILS excluding VAT unless stated.",
      "Final weight is by the weighing slip. Waste is not charged.",
      "Quote valid for {{days}} days."
    ],
    "customerSign": "Customer signature",
    "footer": "Created with EasyBar · easybar.co.il",
    "send": "Send quote",
    "phone": "WhatsApp phone",
    "email": "Email",
    "message": "Message",
    "allowApproval": "Customer can approve the quote via the link",
    "sendEmail": "Send by email",
    "sendWhatsapp": "Send by WhatsApp",
    "sent": "Quote sent"
  },
  "common": {
    "close": "Close",
    "cancel": "Cancel",
    "edit": "Edit",
    "restore": "Restore",
    "loading": "Loading...",
    "error": "Could not load the price list",
    "delete": "Delete"
  },
  "nav": "Price list"
};
